// extracted by mini-css-extract-plugin
export default {"tagCount":"BookingTags_tagCount__--+Q-"};